import { Card } from '../atoms/Card.js';
import { Typography } from '../atoms/Typography.js';

interface StatCardProps {
  label: string;
  value: string | number;
  change?: { value: number; direction: 'up' | 'down' };
  className?: string;
}

export function StatCard({ label, value, change, className = '' }: StatCardProps) {
  return (
    <Card className={className}>
      <Typography variant="caption">{label}</Typography>
      <div className="mt-1 flex items-baseline gap-2">
        <Typography variant="h3" className="!text-neutral-900">
          {value}
        </Typography>
        {change && (
          <span
            className={`text-sm font-medium ${
              change.direction === 'up' ? 'text-green-600' : 'text-red-600'
            }`}
          >
            {change.direction === 'up' ? '+' : '-'}
            {Math.abs(change.value)}%
          </span>
        )}
      </div>
    </Card>
  );
}
